import { NavLink, Outlet } from 'react-router';
import Logo from '@/components/Logo';
import { useLogout } from '@/lib/session';
import type { MeResponse } from '@/lib/api';
import { cn } from '@/lib/utils';

const TABS = [
  { to: '/admin/dashboard', label: 'Tableau de bord' },
  { to: '/admin/imports', label: 'Imports' },
  { to: '/admin/lines', label: 'Lignes' },
  { to: '/admin/promotions', label: 'Promotions' },
  { to: '/admin/reps', label: 'Représentants' },
  { to: '/admin/export', label: 'Export' },
];

export default function AdminLayout({ session }: { session: MeResponse }) {
  const logout = useLogout();

  return (
    <div className="min-h-full">
      <header className="bg-card border-b">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 p-4">
          <div className="flex items-center gap-4">
            <Logo className="h-10" />
            <div>
              <h1 className="text-xl font-bold">Administration</h1>
              <p className="text-muted-foreground text-sm">{session.user.fullName}</p>
            </div>
          </div>
          <button
            onClick={() => logout.mutate()}
            className="border-input h-10 rounded-lg border px-4 text-sm font-medium"
          >
            Déconnexion
          </button>
        </div>
        <nav className="mx-auto flex max-w-6xl gap-1 px-4">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                cn(
                  'border-b-2 px-4 py-3 text-sm font-medium transition-colors',
                  isActive
                    ? 'border-primary text-foreground'
                    : 'text-muted-foreground border-transparent hover:text-foreground',
                )
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="mx-auto max-w-6xl p-6">
        <Outlet />
      </main>
    </div>
  );
}
